import { render, staticRenderFns } from "./WalletBalance.vue?vue&type=template&id=9cbdb2a4&scoped=true"
import script from "./WalletBalance.vue?vue&type=script&lang=js"
export * from "./WalletBalance.vue?vue&type=script&lang=js"
import style0 from "./WalletBalance.vue?vue&type=style&index=0&id=9cbdb2a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbdb2a4",
  null
  
)

export default component.exports